/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Page_Faq_Alone_QInputs */

const en_price_page_faq_alone_q = /** @type {(inputs: Price_Page_Faq_Alone_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I train without a coach?`)
};

const pl_price_page_faq_alone_q = /** @type {(inputs: Price_Page_Faq_Alone_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Czy mogę trenować bez trenera?`)
};

/**
* | output |
* | --- |
* | "Can I train without a coach?" |
*
* @param {Price_Page_Faq_Alone_QInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const price_page_faq_alone_q = /** @type {((inputs?: Price_Page_Faq_Alone_QInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Page_Faq_Alone_QInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_price_page_faq_alone_q(inputs)
	return en_price_page_faq_alone_q(inputs)
});